import React, { Component } from "react";

export class Footer extends Component {
  render() {
    return (
      <div>
        
        <div id="footer">
          <div className="container text-center">
          <p>
              &copy; 2020
            </p>
            <p>
              <a href="./cookies/CENTRO_MEDICO_LLUCMAJOR_SL_Aviso_legal.html">Aviso Legal</a> |
              <a href="./cookies/CENTRO_MEDICO_LLUCMAJOR_SL_Politica_de_PRIVACIDAD_2022.html">Política de privacidad</a> |
              <a href="./cookies/CENTRO_MEDICO_LLUCMAJOR_SL_Politica_de_cookies_(PD_COOKIE_CAPTURE)_2022.html">Política de Cookies</a> 
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
